<template>
  <main
    class="flex-1 relative z-0 overflow-y-auto focus:outline-none"
    tabindex="0"
  >
    <div class="py-6" ref="scrollDiv">
      <div class="mx-auto px-4 sm:px-6 md:px-8 flex flex-row">
        <div class="flex-none text-2xl font-semibold text-gray-900">
          Latest Media
        </div>
        <div
          class="flex flex-1 flex-row items-center justify-end invisible lg:visible"
        >
          <div class="mr-4"><i class="fad fa-th-large text-2xl"></i></div>
          <input
            class="range-slider__range w-0 md:w-48"
            type="range"
            :min="1"
            :max="4"
            v-model="gridCol"
          />
          <div class="ml-4"><i class="fad fa-th text-2xl"></i></div>
        </div>
      </div>
      <div class="w-full h-full w-full text-center" v-if="loading">
        <h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
      </div>
      <div class="mx-auto px-4 sm:px-6 md:px-8 mt-4">
        <div
          class="grid gap-4 grid-cols-1"
          :class="['lg:grid-cols-' + gridCol]"
        >
          <VideoCard
            v-for="video in videos"
            v-bind:key="'latest-' + video.id"
            :video="video"
          />
        </div>
      </div>
      <div ref="loadMoreDiv" class="h-10"></div>
    </div>
  </main>
</template>

<script>
import * as Config from "@/config";
import { mapGetters } from "vuex";

import VideoCard from "@/components/VideoCard";

export default {
  name: "MediaLatestUploaded",
  data() {
    return {
      videos: [],
      chasersCount: 0,
      interval: null,
      lastUpdate: null,
      loading: true,
      gridCol: 3,

      last_page: null,
      bottom: false,
      index: 1,
      showVideoPopover: false,
      shouldLoadMore: null
    };
  },
  components: {
    VideoCard
  },
  created() {
    // TODO: We must add auto update functionality... possibly websockets?
    this.$nextTick(() => {
      this.getVideos();
      this.lastUpdate = Date.now();

      this.$eventBus.$on("scroll", this.handleScroll);
      this.shouldLoadMore = setInterval(
        function() {
          this.handleScroll();
        }.bind(this),
        250
      );
    });
  },
  destroyed() {
    this.$eventBus.$off("scroll");
    clearInterval(this.interval);
    clearInterval(this.shouldLoadMore);
  },
  watch: {
    bottom(bottom) {
      if (bottom) {
        this.getVideos();
      }
    }
  },
  methods: {
    ...mapGetters(["getAuthorizationHeader"]),
    async getVideos() {
      if (this.last_page !== null && this.index > this.last_page) return;
      let res = await this.$http.get(
        Config.apiPath + "/api/v2/media/latest?paginate=true&page=" + this.index
      );
      let responseVideos = res.data.data;
      for (const video of responseVideos) {
        this.videos.push(video);
      }

      this.bottom = false;
      this.last_page = res.data.last_page;
      this.$set(this, "loading", false);
      this.index += 1;

      // SLIDE OVER DEBUG
      // this.$eventBus.$emit("openSlideOver", responseVideos[0]);
    },
    handleScroll() {
      this.bottom = this.bottomVisible();
    },
    bottomVisible() {
      const rect = this.$refs.loadMoreDiv.getBoundingClientRect();

      const isInViewport =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth);
      return isInViewport;
    }
  }
};
</script>

<style>
/* range slider styles */
.range-slider__range {
  -webkit-appearance: none;
  height: 10px;
  border-radius: 5px;
  background: #d7dcdf;
  outline: none;
  padding: 0;
  margin: 0;
}
.range-slider__range::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: rgba(17, 24, 39, var(--tw-bg-opacity));
  cursor: pointer;
  transition: background 0.15s ease-in-out;
}
.range-slider__range::-webkit-slider-thumb:hover {
  background-color: rgba(17, 24, 39, var(--tw-bg-opacity));
}
.range-slider__range:active::-webkit-slider-thumb {
  background-color: rgba(17, 24, 39, var(--tw-bg-opacity));
}
.range-slider__range::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border: 0;
  border-radius: 50%;
  background-color: rgba(17, 24, 39, var(--tw-bg-opacity));
  cursor: pointer;
  transition: background 0.15s ease-in-out;
}
.range-slider__range::-moz-range-thumb:hover {
  background-color: rgba(17, 24, 39, var(--tw-bg-opacity));
}
.range-slider__range:active::-moz-range-thumb {
  background-color: rgba(17, 24, 39, var(--tw-bg-opacity));
}
.range-slider__range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 3px #fff, 0 0 0 6px #2d3748;
}
.range-slider__value {
  display: inline-block;
  position: relative;
  width: 60px;
  color: #fff;
  line-height: 20px;
  text-align: center;
  border-radius: 3px;
  background-color: rgba(17, 24, 39, var(--tw-bg-opacity));
  padding: 5px 10px;
  margin-left: 8px;
}
.range-slider__value:after {
  position: absolute;
  top: 8px;
  left: -7px;
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-right: 7px solid #2c3e50;
  border-bottom: 7px solid transparent;
  content: "";
}
::-moz-range-track {
  background: #d7dcdf;
  border: 0;
}
input::-moz-focus-inner,
input::-moz-focus-outer {
  border: 0;
}
.card-grid-leave-active {
  transition: transform 0.3s ease-in, opacity 0.2s ease;
  transform: scale(0.5);
  opacity: 0;
  z-index: 0;
}

.card-grid-move {
  transition: all 0.3s ease;
  z-index: 1;
}
</style>
